import logger from 'nandos-dev-logger'
import LibraryModule from '../index'

export default function (value, style='default') {
	if(isValidDate(value)) {
		// fullFriendly style requires some extra massaging, its not just a simple Intl.DateTimeFormat formater
		if(style == 'fullFriendly')
			return fullFriendly(value)
		else
			return LibraryModule.i18n.d( value, style )
	}
	else {
		logger.error('Nandos i18n', 'Attempted to format an Invalid date')
	}
}

function fullFriendly(date) {

  let dateStart = new Date(date).setHours(0,0,0,0)
  let today = new Date().setHours(0,0,0,0)
  let tomorrow = new Date(new Date().setDate(new Date(today).getDate() + 1)).setHours(0,0,0,0)
  let yesterday = new Date(new Date().setDate(new Date(today).getDate() - 1)).setHours(0,0,0,0)

  if(dateStart == today)
    return `${capitalizeFirstLetter(LibraryModule.i18n.t('common.dates.today'))}, ${LibraryModule.i18n.d(date, 'time')}`
  if(dateStart == tomorrow)
    return `${capitalizeFirstLetter(LibraryModule.i18n.t('common.dates.tomorrow'))}, ${LibraryModule.i18n.d(date, 'time')}`
  else if(dateStart == yesterday)
    return `${capitalizeFirstLetter(LibraryModule.i18n.t('common.dates.yesterday'))}, ${LibraryModule.i18n.d(date, 'time')}`
  else
    return LibraryModule.i18n.d(date, 'full')
}

const capitalizeFirstLetter = ([ first, ...rest ], locale = LibraryModule.i18n.locale) => {
  return first.toLocaleUpperCase(locale) + rest.join('')
}

const isValidDate = d => Number.isInteger(d) || (d instanceof Date && !isNaN(d))